<template>
<v-btn-toggle dark mandatory>
    <v-btn color="primary" block  @click="changeIsForRentFlag(true)" value="true">
        Alquiler
    </v-btn>
    <v-btn color="primary" block  @click="changeIsForRentFlag(false)" value="false">
        Compra
    </v-btn>
</v-btn-toggle>
</template>

<script>
export default {
  props: ['isForRent'],
  methods: {
      changeIsForRentFlag (value) {
          this.$emit('isForRentChanged', value);
      }
  }
};
</script>

<style scoped>

@media (min-width: 1024px) {
    button {
        width:8vw!important;
    }
}

@media (min-width: 324px) and (max-width: 1023px) {
    button {
        width:40vw!important;
    }
}
</style>
